import api from "../../index";

// Get a generation by id
export const getGenerationById = async (id: any) => {
  return await api.get(`/generation/${id}`);
};

// Archive a generation
export const archiveGeneration = async (id: any) => {
  return await api.put(`/generation/archive/${id}`);
};

// Archive multiple generations
export const archiveMultipleGenerations = async (ids: any) => {
  return await api.put(`/generation/archive-multiple`, { ids: ids });
};

// Restore a generation
export const restoreGeneration = async (id: any) => {
  return await api.put(`/generation/restore/${id}`);
};

// Delete a generation
export const deleteGeneration = async (id: any) => {
  return await api.delete(`/generation/delete/${id}`);
};

// Delete multiple generations
export const deleteMultipleGenerations = async (ids: any) => {
  const config = {
    data: { ids }, // Place the ids inside the data property
  };
  return await api.delete(`/generation/delete-multiple`, config);
};
